module.exports = __webpack_public_path__ + "media/images/img01-530694f87b531aeff093963ba6e069c1.png";